import { render } from "./SelectionMenuStep6.vue?vue&type=template&id=5316e2c3&scoped=true"
import script from "./SelectionMenuStep6.vue?vue&type=script&lang=ts"
export * from "./SelectionMenuStep6.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5316e2c3"

export default script